// Usage quota buckets shared by REST API routes and MCP tool calls.
export const USAGE_BUCKETS = {
  READS: "reads",
  WRITES: "writes",
  RESPONSES: "responses",
} as const;
